import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetPricingHubCustomersDocument = gql`
  query GetPricingHubCustomers {
    getPricingHubCustomers {
      realized_gm_percentage
      weekly_gross_profit_in_micros
      weekly_revenue_in_micros
    }
  }
`;
export function useGetPricingHubCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetPricingHubCustomersQuery,
    Types.GetPricingHubCustomersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPricingHubCustomersQuery,
    Types.GetPricingHubCustomersQueryVariables
  >(GetPricingHubCustomersDocument, options);
}
export function useGetPricingHubCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPricingHubCustomersQuery,
    Types.GetPricingHubCustomersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPricingHubCustomersQuery,
    Types.GetPricingHubCustomersQueryVariables
  >(GetPricingHubCustomersDocument, options);
}
export type GetPricingHubCustomersQueryHookResult = ReturnType<
  typeof useGetPricingHubCustomersQuery
>;
export type GetPricingHubCustomersLazyQueryHookResult = ReturnType<
  typeof useGetPricingHubCustomersLazyQuery
>;
export type GetPricingHubCustomersQueryResult = Apollo.QueryResult<
  Types.GetPricingHubCustomersQuery,
  Types.GetPricingHubCustomersQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetPricingHubCustomersQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetPricingHubCustomersQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetPricingHubCustomersQuery,
    Types.GetPricingHubCustomersQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetPricingHubCustomersQuery,
    Types.GetPricingHubCustomersQueryVariables
  >(GetPricingHubCustomersDocument, options);
}

/**
 * Wrapped version of useGeneratedGetPricingHubCustomersLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetPricingHubCustomersLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetPricingHubCustomersQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetPricingHubCustomersQuery,
    Types.GetPricingHubCustomersQueryVariables
  >(GetPricingHubCustomersDocument, lazyOptions);
}
